// Static data - text comes from /i18n/translations.js via tent ids

export const heroImage =
  'https://media.base44.com/images/public/69f0b5ea9a2e3d8aa4cf6c6f/6ce555675_generated_c0c934c8.png';

export const atmosphereImage =
  'https://images.unsplash.com/photo-1775476793931-cb484f197760?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85';

// Tent structures - identified by id; translatable text lives in translations.js under tents[id]
export const structures = [
  {
    id: 'pagode',
    image:
      'https://media.base44.com/images/public/69f0b5ea9a2e3d8aa4cf6c6f/f525a5871_generated_d8fb8874.png',
    capacity: 'Max. 10-25',
    dimensions: '5m x 5m',
    material: 'PVC 650g/m²',
  },
  {
    id: 'stretch',
    image: '/images/stretch-tent.jpg',
    capacity: 'Max. 95-125',
    dimensionsKey: 'custom',
    material: 'PVC zeil 680g/m²',
  },
  {
    id: 'glass',
    image:
      'https://images.unsplash.com/photo-1675376616537-c8aa9ddc9977?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHx3aGl0ZSUyMHRlbnQlMjB3YWxscyUyMHdlZGRpbmd8ZW58MHx8fHwxNzg4MzcwNjg4fDA&ixlib=rb-4.1.0&q=85',
    capacity: 'Max. 200',
    dimensions: '10m x 20m',
    material: 'PVC zeil 680g/m²',
  },
  {
    id: 'silhouette',
    image: '/images/sailcloth-tent.png',
    comingSoon: true,
    capacity: 'Max. 80-100',
    dimensions: '15m x 30m',
    material: 'Block-out PVC',
  },
];

// Stat icons (text comes from translations)
export const statKeys = [
  { key: 'structures', value: '12+', icon: 'tent' },
  { key: 'flooring', value: '500m²', icon: 'grid' },
  { key: 'countries', value: '2', icon: 'globe' },
  { key: 'service', icon: 'zap' }, // value comes from translations
];

// Inspiration / portfolio image grid (no titles/locations)
export const portfolio = [
  {
    id: 1,
    image:
      'https://media.base44.com/images/public/69f0b5ea9a2e3d8aa4cf6c6f/02cb58ba8_generated_4cd4d53c.png',
  },
  {
    id: 2,
    image:
      'https://media.base44.com/images/public/69f0b5ea9a2e3d8aa4cf6c6f/4a45fb7df_generated_c020e7b7.png',
  },
  {
    id: 3,
    image: '/images/stretch-tent.jpg',
  },
  {
    id: 4,
    video: '/videos/give-gaas-2026.mp4',
  },
];

// Feature icon keys for home about section
export const featureKeys = [
  { key: 'quality', icon: 'shield' },
  { key: 'service', icon: 'wrench' },
  { key: 'premium', icon: 'award' },
];

// About values keys
export const aboutValueKeys = ['precision', 'craftsmanship', 'service', 'reliability'];

// Extra equipment keys
export const extraKeys = ['flooring', 'furniture', 'climate'];
